module.exports = __webpack_public_path__ + "static/media/QuoteHeader3Image.b6d2cc68.png";